import { render, staticRenderFns } from "./ColaE.vue?vue&type=template&id=30e4e50c&scoped=true"
import script from "./ColaE.vue?vue&type=script&lang=js"
export * from "./ColaE.vue?vue&type=script&lang=js"
import style0 from "./ColaE.vue?vue&type=style&index=0&id=30e4e50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e4e50c",
  null
  
)

export default component.exports